import styled, { keyframes } from 'styled-components';

const spinnerSize = 20;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  50%{
    transform: rotate(540deg);
  }
  100% {
    transform: rotate(1080deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dashoffset: ${spinnerSize * 0.5};
  }
  50% {
    stroke-dashoffset: ${spinnerSize * 3.14};
  }
  100% {
    stroke-dashoffset: ${spinnerSize * 0.5};
  }
`;

export const SpinnerWrapper = styled.svg`
  circle {
    fill: transparent;
    stroke: ${({ theme }) => theme.colors.primary[500]};
    stroke-width: 2;
    stroke-linecap: round;
    stroke-dasharray: ${spinnerSize * 3.14}px;
    stroke-dashoffset: -10;
    transform-origin: 50% 50%;
    animation: ${rotate} 3s linear infinite, ${dash} 2.5s linear infinite;
  }
`;
